import api from './api';

export const projectStatusService = {
  getAll: () => api.get('/project-statuses/'),
  create: (statusData) => api.post('/project-statuses/', statusData),
  update: (id, statusData) => api.put(`/project-statuses/${id}`, statusData),
  delete: (id) => api.delete(`/project-statuses/${id}`),
  archive: (id) => api.post(`/project-statuses/${id}/archive`),
  restore: (id) => api.post(`/project-statuses/${id}/restore`),
  initialize: () => api.post('/project-statuses/initialize'),
};
